import React from "react";

import { SavePopupMessageProps } from "../../types/save_popup_message";

const SavePopupMessage: React.FC<SavePopupMessageProps> = ({
    popupType,
    popupMessage,
}) => {
    return (
        <div
            className={`fixed top-4 left-1/2 transform -translate-x-1/2 p-4 rounded-xl text-white shadow-lg ${
                popupType === "success" ? "bg-green-500" : "bg-rose-500"
            }`}
        >
            {popupMessage}
        </div>
    );
};

export default SavePopupMessage;
